module.exports = __webpack_public_path__ + "static/media/icon_butonnage.888ec052.svg";